import { Button, IconChevronRightDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import Link from 'components/Link'
import { useHelpCenterEvents } from '../../../events'
import { BrandKey, productsByKey } from '../../../utils'
import classes from './GladlyBreadcrumbs.module.scss'

interface GladlyBreadcrumbsProps {
  brandKey?: BrandKey
  answerName?: string
}
export const GladlyBreadcrumbs = ({
  brandKey,
  answerName,
}: GladlyBreadcrumbsProps) => {
  const { t } = useTranslation('@mc/next')
  const product = brandKey ? productsByKey[brandKey] : undefined

  const { trigger } = useHelpCenterEvents()

  return (
    <nav className={`${classes.container} position-sticky mc-bg-dark mc-w-100`}>
      <ol
        className={`${classes.breadcrumbs} container d-flex flex-gap-1 align-items-center mc-text-h7 mc-py-2`}
      >
        <li className='d-flex flex-gap-1 align-items-center flex-shrink-0'>
          {/* as property in Button is conditional since we need to force a full page refresh to remove lingering third party scripts */}
          <Button
            className='flex-shrink-0 mc-py-1 mc-px-3 mc-corners--1'
            size='small'
            kind='secondary'
            render={<a href={paths.helpCenter} />}
            onClick={() =>
              trigger('click', {
                location: 'Breadcrumb',
                action: t('helpCenter.breadcrumbs.HOME'),
              })
            }
          >
            {t('helpCenter.breadcrumbs.HOME')}
          </Button>
        </li>
        {brandKey && (
          <li className='d-flex flex-gap-1 align-items-center flex-shrink-0'>
            <IconChevronRightDefault />
            {answerName ? (
              <Button
                className='flex-shrink-0 mc-py-1 mc-px-3 mc-text-small mc-corners--1'
                size='small'
                kind='secondary'
                render={
                  <Link href={paths.helpCenterForProduct(product!.slug)} />
                }
                onClick={() =>
                  trigger('click', {
                    location: 'Breadcrumb',
                    action: t(`helpCenter.breadcrumbs.${brandKey}`),
                  })
                }
              >
                {t(`helpCenter.breadcrumbs.${brandKey}`)}
              </Button>
            ) : (
              <span>{t(`helpCenter.breadcrumbs.${brandKey}`)}</span>
            )}
          </li>
        )}
        {answerName && (
          <li className='d-flex flex-gap-1 align-items-center flex-shrink-0'>
            <IconChevronRightDefault />
            <span>{answerName}</span>
          </li>
        )}
      </ol>
    </nav>
  )
}
